import {put} from "redux-saga/effects";
import logger from "lib/log";
import {setCheckoutError} from "state/school_money/actions";

// When we get a Secure Trading error, log the details and recover or die.
export default function* handleSecureTradingErrorSaga(action) {
  const {error} = action.payload;
  yield* errMessages(error);
  logger.warn("Secure Trading API error", error.description + "(code: " + error.code + ")");
}

// Detect and use predefined message, if code doesn't match use the error message
// from Secure Trading.
function* errMessages(error) {

  switch (error.code) {
    case "SM001": yield put(setCheckoutError("PROGRAMMING_ERROR")); return;
    case "10003": yield put(setCheckoutError("ERROR_CARD_DETAILS_INCORRECT", error.code)); return;
    case "50003": yield put(setCheckoutError("ERROR_PROCESS_PAYMENT", error.code)); return;
    case "60010": yield put(setCheckoutError("ISSUING_BANK_SYSTEM_ERROR", error.code)); return;
    case "70000": yield put(setCheckoutError("ERROR_ISSUING_BANK_DECLINED_PAYMENT", error.code)); return;
    case "60022": yield put(setCheckoutError("ERROR_AUTHORISE_PAYMENT", error.code)); return;
    case "00000": yield put(setCheckoutError("UNKNOWN_ERROR", error.code)); return;
    case "30000": return;
    case "DUPLICATE_TRANSACTION": yield put(setCheckoutError("DUPLICATE_TRANSACTION")); return;
    case "INVALID_AMOUNT": yield put(setCheckoutError("INVALID_AMOUNT")); return;
    case "SERVER_ERROR": yield put(setCheckoutError("SERVER_ERROR")); return;
    case "INVALID_RESPONSE": yield put(setCheckoutError("INVALID_RESPONSE")); return;
    case "API_ERROR": yield put(setCheckoutError("API_ERROR")); return;
    case "INIT_FAIL": yield put(setCheckoutError("INIT_FAIL")); return;
    case "BUYER_ACCOUNT_ERROR": yield put(setCheckoutError("BUYER_ACCOUNT_ERROR")); return;
    case "MERCHANT_ACCOUNT_ERROR": yield put(setCheckoutError("MERCHANT_ACCOUNT_ERROR")); return;
    case "GOOGLE_PAY_INVALID_CARD_DETAILS": yield put(setCheckoutError("GOOGLE_PAY_INVALID_CARD_DETAILS")); return;

    // When code doesn't match list above use a general error message.
    default: yield put(setCheckoutError("ERROR_UNABLE_TO_PROCESS_PAYMENT")); return;
  }
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/handleSecureTradingErrorSaga.js